import { Subject } from 'rxjs';
import { userApi } from '../api/user';
import * as TradingView from '../charting_library';
import { TVContext } from "../hub/context";
import { getJson, setVal, VS } from "../storage";
import { SyncerUpdateType, TVSyncer } from "./sync";
import { SyncerChange, TVSyncerTool } from "./syncitem";
import { hub, UpdateViewField } from '../hub';
import { DrawingCachedItem, DrawingCacheItems, DrawState } from '../cacheStorage';
import { DrawingEventType, StudyOrDrawingAddedToChartEventParams } from '../charting_library';


export class DrawingSync extends TVSyncerTool {
    private dstate: DrawingCachedItem;
    private scheduledSaving = false;
    constructor(syncer: TVSyncer, tvd: TVContext) {
        super(syncer, tvd);
    }


    private async updateDrawing(source: string, state: TradingView.LineToolsAndGroupsState) {
        this.syncer.beginLocalUpdate();
        try {
            this.tvd.tv.activeChart().removeAllShapes();
            if (state)
                await this.tvd.tv.activeChart().applyLineToolsState(state);

        } finally {
            this.syncer.endLocalUpdate();
        }
    }

    async save(source: string) {
        this.syncer.beginLocalUpdate();
        try {
            const tid = this.tvd.tid;
            this.dstate = await hub.cache.drawings.load(tid);

            let state = this.tvd.tv.activeChart().getLineToolsState();
            const drawings = state?.sources;


            if (!drawings) return;


            this.dstate.set(state?.sources);
            // console.log(this.dstate.lines);
            hub.cache.drawings.save(tid);


            state = this.loadFromState();
            for (const g of this.syncer.items) {
                if (g.drawings == this || g.drawings.tvd.tid != tid)
                    continue;
                await g.drawings.updateDrawing(source, state);
            }
        } finally {
            this.syncer.endLocalUpdate();
        }
    }
    override clear() {
        this.syncer.beginLocalUpdate();
        try {
            this.dstate = null;
            if (this.tvd.isTvReady())
                this.tvd.tv.activeChart().removeAllShapes();
        } finally {
            this.syncer.endLocalUpdate();
        }
    }
    private loadFromState() {
        if (this.dstate && this.dstate.lines.length > 0) {
            const state: TradingView.LineToolsAndGroupsState = {
                groups: new Map(),
                sources: new Map<TradingView.EntityId, TradingView.LineToolState>()
            };
            this.dstate.lines.forEach(st => {
                if (st?.id == null)
                    return;
                state.sources.set(st.id, st);
            });
            return state;
        }
        return null;
    }
    private log(msg: string) {
        console.log(`Drawings ${this.tvd.id},${this.tvd.tid}: ${msg}`);
    }
    private async prepareDrawings() {
        const tid = this.tvd.tid;
        this.syncer.beginLocalUpdate();
        try {
            this.clear();
            this.dstate = await hub.cache.drawings.load(tid);
            let state = this.loadFromState();
            if (state)
                await this.tvd.tv.activeChart().applyLineToolsState(state);
        } finally {
            this.syncer.endLocalUpdate();
        }
    }

    private scheduleSave(source: string) {
        if (this.scheduledSaving)
            return;
        this.scheduledSaving = true;
        setTimeout(() => {
            this.scheduledSaving = false;
            this.save(source);
        }, 100);
    }

    override onInit() {
        this.tvd.tv.subscribe("drawing_event", (sourceId: TradingView.EntityId, drawingEventType: DrawingEventType) => {
            if (this.syncer.isInited()) {
                // console.log(drawingEventType + ',' + sourceId);
                switch (drawingEventType) {
                    case 'click':
                        if (hub.debugApi) {
                            this.tvd.smpa.markTools.markPhases(sourceId);
                            this.tvd.smpa.updateView(false, UpdateViewField.Some);
                        }
                        break;
                    case 'create': {
                        this.dstate.add(sourceId);
                        this.scheduleSave(drawingEventType);
                    } break;
                    case 'remove':
                        if (this.dstate?.delete(sourceId))
                            this.scheduleSave(drawingEventType);
                        break;
                    case 'points_changed':
                        if (!this.dstate?.has(sourceId)) {
                            if (hub.admin) {
                                this.syncer.items[this.tvd.id].barReplay?.onMoved(sourceId);
                                this.syncer.items[this.tvd.id].fixData?.onMoved(sourceId);
                                this.syncer.items[this.tvd.id].dayk?.onMoved(sourceId);
                            }
                        }
                        else {
                            this.scheduleSave(drawingEventType);
                        }
                        break;
                    case 'properties_changed':
                    case 'move':
                        if (!this.dstate?.has(sourceId) || !this.syncer.isReleased(this.tvd))
                            return;
                        this.scheduleSave(drawingEventType);
                        break;
                }
            }
        });
        this.prepareDrawings();
    }

    override onBeforeChange(type: SyncerChange) {
        if (type != SyncerChange.Symbol)
            return;
        this.clear();
    }
    override onEndChange(type: SyncerChange) {
        if (type != SyncerChange.Symbol)
            return;
        this.prepareDrawings();
    }
}
